import { create } from "zustand";
import { persist, devtools } from "zustand/middleware";
import { DeleteData, EditData } from "./AuthStore";

const CategoryStore = set => ({
	data: null,
	status: "",
	getSearchCategory: payload => {
		set(
			state => ({
				mainSearch:
					payload?.search === state?.search
						? payload?.data || payload
						: state?.mainSearch,
				isFound: true,
			}),
			false,
			"getSearchCategory"
		);
	},
	getSearch: payload => {
		set({ data: payload?.data || payload }, false, "getSearch");
	},
	resetCategorySearch: () => {
		set({ search: "", mainSearch: null, isFound: null }, false, "getSearch");
	},
	getCategory: payload => {
		set({ data: payload?.data || payload }, false, "getCategory");
	},
	getAllCategory: payload => {
		set({ allData: payload?.data || payload }, false, "getAllCategory");
	},
	addCategory: payload => {
		let data = payload?.data || payload;

		set(
			state => ({
				data: {
					...state?.data,
					docs: state?.data?.docs ? [data, ...state?.data?.docs] : [data],
					totalDocs: state?.data?.totalDocs ? 1 + state?.data?.totalDocs : 1,
					docsTotal: state?.data?.docsTotal ? 1 + state?.data?.docsTotal : 1,
				},
				status: "added",
			}),
			false,
			"addCategory"
		);
	},
	deleteCategory: payload => {
		let data = payload?.data || payload;
		set(
			state => ({
				data: {
					...state?.data,
					docs: DeleteData(state?.data?.docs, data),
					totalDocs: state?.data?.totalDocs ? state?.data?.totalDocs - 1 : 0,
					docsTotal: state?.data?.docsTotal ? state?.data?.docsTotal - 1 : 0,
				},
				status: "deleted",
			}),
			false,
			"deleteCategory"
		);
	},
	updateCategory: payload => {
		let data = payload?.data || payload;
		set(
			state => ({
				data: {
					...state?.data,
					docs: EditData(state?.data?.docs, data),
				},
				status: "updated",
			}),
			false,
			"editCategory"
		);
	},
	subjectFail: () => {
		set({ status: "", isFound: null });
	},
	logoutCategory: () => {
		set({ status: "", isFound: null, data: null, mainSearch: null });
	},
});

const useCategoryStore = create(
	devtools(
		persist(CategoryStore, {
			name: "category",
		})
	)
);

export default useCategoryStore;
